import DiaporamaAnneDelrez from "./DiaporamaAnneDelrez";
export default DiaporamaAnneDelrez;
